import { useRefundAccount } from '@/features/update-account'
import { formatDateWithDayOfWeek } from '@/shared/lib'

type RefundAccountProps = {
  contractId: number
}

export const RefundAccount = ({ contractId }: RefundAccountProps) => {
  const { isRefunded, refundAccount, refundedAt } = useRefundAccount({
    contractId,
  })

  return (
    <div className="space-y-3">
      <h3 className="typo-body1 font-semibold text-black">환불 계좌</h3>

      {(() => {
        if (isRefunded) {
          return (
            <div className="space-y-2">
              <p className="typo-label1 font-medium text-gray-900">
                {refundAccount}
              </p>
              <p className="typo-body1 font-bold text-purple-500">
                {formatDateWithDayOfWeek({
                  date: refundedAt!,
                })}{' '}
                환불 완료
              </p>
            </div>
          )
        }

        return (
          <p className="typo-label1 font-medium text-gray-900">
            {refundAccount}
          </p>
        )
      })()}
    </div>
  )
}
